import ServiceLayout from "@/components/ServiceLayout";

export default function Claims() {
  return (
    <ServiceLayout
      slug="medical-claims-billing"
      eyebrow="Solutions · Medical Claims & Billing"
      title="Strengthen the revenue behind the care you provide."
      intro="For hospitals, skilled nursing facilities, and healthcare practices, billing is where care meets cash flow. Through TFSC and 24-7 Consultancy LLC, Riverstone helps healthcare organizations address billing complexity, denials, and outstanding receivables—so the revenue behind the care you provide is collected correctly."
      image="https://images.unsplash.com/photo-1758691462848-31a39258dbd8?q=80&w=1600&auto=format&fit=crop"
      imageAlt="Healthcare administrator working on billing at a desk"
      ctaLabel="Discuss Revenue Cycle Support"
      whoFor={[
        "Hospitals, skilled nursing facilities, and healthcare practices.",
        "Practices with growing denial rates or aging receivables.",
        "Organizations weighing in-house billing against rising complexity.",
        "Groups whose credentialing and enrollment have fallen behind.",
      ]}
      problems={[
        "Claims denied or underpaid for preventable reasons.",
        "Receivables that age quietly while staff chase follow-up.",
        "Payer rules that change faster than internal processes can track.",
        "Credentialing and enrollment backlogs that stall new revenue.",
      ]}
      capabilities={[
        { title: "Medical billing & coding", body: "Accurate, compliant claims prepared to payer standards." },
        { title: "Claims follow-up", body: "Persistent pursuit of every claim submitted." },
        { title: "Denial management", body: "Understanding why claims are denied—and correcting the pattern." },
        { title: "Accounts receivable support", body: "Bringing aged receivables back into view and into play." },
        { title: "Credentialing & enrollment", body: "Keeping providers enrolled and payer-ready." },
        { title: "Administrative support", body: "Practical help with the paperwork around the revenue cycle." },
      ]}
      providerRole={[
        {
          title: "TFSC / 24-7 Consultancy’s role — delivery",
          body: "TFSC, together with 24-7 Consultancy LLC, provides full billing solutions for U.S. hospitals, skilled nursing facilities, and healthcare practices—managing the revenue cycle, ensuring compliance, and working to maximize reimbursements through accurate billing and coding.",
        },
        {
          title: "Riverstone’s role — connection & continuity",
          body: "Riverstone introduces you, helps frame the problem, and remains a point of contact. Billing decisions, compliance, and day-to-day revenue-cycle work belong entirely to the provider.",
        },
      ]}
      conversation={[
        { title: "Your current revenue cycle", body: "Systems, staffing, volumes, and the pain points your team feels most." },
        { title: "Where value may be", body: "Denials, AR aging, credentialing—where better process could return revenue." },
        { title: "Scope & process", body: "What support would look like, how handoffs work, and what the first 90 days involve." },
      ]}
      faqs={[
        { q: "We already have billing staff — why consider this?", a: "Many organizations use a provider to handle overflow, specific payers, denial backlogs, or credentialing. Some fully outsource. The right structure depends on your situation." },
        { q: "Who handles our patient and claims data?", a: "The provider manages billing under its own compliance obligations. Safeguards and data handling are discussed directly during your evaluation." },
        { q: "Can aged receivables be recovered?", a: "Denial management and AR follow-up exist to address aged accounts. What’s recoverable depends on the details of each claim, which the specialists review first." },
        { q: "What does it cost?", a: "Pricing is set by the provider based on scope and volumes, and is confirmed during your evaluation—not by Riverstone." },
      ]}
    />
  );
}
